import classNames from 'classnames';
import { PureComponent, ReactNode } from 'react';
import './index.scss';

interface Props {
  children: ReactNode;
  emptyValueString: string;
  id?: string;
  value?: string | number;
}

export class InputDisabled extends PureComponent<Props> {
  public static demoProps = [
    { value: 'Some value' },
    { value: '' },
    { value: 0 },
    {
      value: null,
      children: (
        <div>
          <span className="mdi mdi-close" />
          Children are only rendered if the value is OK
        </div>
      ),
    },
  ];

  public static defaultProps = {
    children: null,
    emptyValueString: '',
  };

  private renderValue() {
    const { value, children, emptyValueString } = this.props;
    if (!value && value !== 0 && !children) {
      return emptyValueString;
    }
    if (children) {
      return children;
    }
    return value;
  }

  public render() {
    const { id, children, value } = this.props;
    const classes = {
      InputDisabled: true,
      'InputDisabled--empty': !value && value !== 0 && !children,
    };
    return (
      <div id={id} className={classNames(classes)}>
        {this.renderValue()}
      </div>
    );
  }
}
